import * as actionTypes from "./actionTypes";

export const setSearchString = str => {
  return {
    type: actionTypes.SET_SEARCH_STRING,
    str
  };
};

export const deleteSearchString = () => {
  return {
    type: actionTypes.DELETE_SEARCH_STRING
  };
};

export const updateSearch = str => {
  return dispatch => {
    dispatch(setSearchString(str));
  };
};

export const deleteSearch = () => {
  return dispatch => {
    dispatch(deleteSearchString());
  };
};
